<template>
  <div
    class="select-all-wrapper w-100 d-flex justify-space-between align-center"
    :class="{
      'mb-10': $vuetify.breakpoint.smAndUp,
      'mb-6': !$vuetify.breakpoint.smAndUp
    }"
  >
    <div
      class="select-all--checkbox"
      :class="{
        'd-flex align-start': !$vuetify.breakpoint.smAndUp
      }"
    >
      <input id="selectAllCart" type="checkbox" @click.prevent="$emit('input', selectAllProxy)" v-model="selectAllProxy" />
      <label for="selectAllCart"></label>
      <div
        :class="{
          'ml-15': $vuetify.breakpoint.smAndUp,
          'ml-8': !$vuetify.breakpoint.smAndUp
        }"
      >
        {{ $t('label.selectAll') }}
      </div>
    </div>
    <button class="align-self-end" @click="$emit('remove')">{{ $t('button.remove') }}</button>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: true }
  },

  data: () => ({
    selectAllProxy: false
  }),

  methods: {},

  watch: {
    value(val) {
      this.selectAllProxy = val
    }
  }
}
</script>

<style lang="scss" scoped>
/* Base for label styling */
[type='checkbox']:not(:checked),
[type='checkbox']:checked {
  appearance: none;
}

[type='checkbox']:not(:checked) + label,
[type='checkbox']:checked + label {
  position: relative;
  font-size: 1.05em;
  line-height: 1.7;
  cursor: pointer;
  display: inline-block;
}

/* checkbox circle */
[type='checkbox']:not(:checked) + label:before,
[type='checkbox']:checked + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 1.5em;
  height: 1.5em;
  border: 1px solid #aaa;
  background: #fff;
  border-radius: 999em;
  -webkit-transition: all 0.275s;
  transition: all 0.275s;

  @media only screen and (min-width: 640px) {
    width: 2em;
    height: 2em;
  }
}

[type='checkbox']:checked + label:before {
  background-color: var(--v-light-green-base);
}

/* checked mark aspect */
[type='checkbox']:not(:checked) + label:after,
[type='checkbox']:checked + label:after {
  content: '';
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  width: 0.5em;
  height: 1em;
  position: absolute;
  top: 0.4em;
  left: 0.75em;
  font-size: 0.75em;
  color: white;
  line-height: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;

  @media only screen and (min-width: 640px) {
    top: 0.1em;
    left: 0.45em;
    font-size: 1.375em;
  }
}

/* checked mark aspect changes */
[type='checkbox']:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0) rotate(-45deg);
  transform: scale(0) rotate(-45deg);
}

[type='checkbox']:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1) rotate(45deg);
  transform: scale(1) rotate(45deg);
}

/* Accessibility */
[type='checkbox']:checked:focus + label:before,
[type='checkbox']:not(:checked):focus + label:before {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) inset, 0 0 0 4px rgba(#74ce00, 0.5);
}

.cart-image {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
}
</style>
